export default function UnitsMetric({ metricColor, text, metric }) {
  return (
    <div className="flex items-center">
      <div className={`text-lg font-extrabold ${metricColor}`}>{metric}</div>
      <div className="ml-2">{text}</div>
    </div>
  )
}